import { lazy } from 'react';
import RolesGuard from 'src/components/RolesGuard';
import {
    EMAIL_MARKETING_AUTH,
    LEAD_TASKS_CALENDAR_AUTH,
    READ_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';
import { MailingView } from 'src/views/mail/MalingView';

export const Calendars = [
    {
        exact: true,
        path: '/calendar',
        guard: RolesGuard,
        roles: [
            'rockstar',
            'admin',
            'super admin',
            'marketing',
            'digital marketing',
            'user',
            'general manager',
            'sales manager',
        ],
        component: lazy(() => import('src/views/calendar/CalendarView')),
    },
];

export const Management = [
    {
        exact: true,
        path: '/management/tasks',
        guard: RolesGuard,
        roles: [
            'rockstar',
            'admin',
            'super admin',
            'general manager',
            'marketing',
            'sales manager',
        ],
        component: lazy(() => import('src/views/tasks/TaskListview')),
    },
    {
        exact: true,
        path: '/management/manage-recordings',
        guard: RolesGuard,
        roles: ['rockstar', 'super admin', 'general manager', 'sales manager'],
        component: lazy(
            () => import('src/views/storeRecording/RecordingsDetailsView')
        ),
    },
    {
        exact: true,
        path: '/tasks',
        guard: PermissionsGuard,
        roles: {
            permission: LEAD_TASKS_CALENDAR_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/tasks/TasksView')),
    },
    {
        exact: true,
        path: '/management/mailing',
        guard: RolesGuard,
        roles: [
            'rockstar',
            'super admin',
            'general manager',
            'admin',
            'marketing',
        ],
        component: lazy(() => import('src/views/email/EmailDetailsView')),
    },
];

export const Utils = [
    {
        exact: true,
        path: '/management/load-leads',
        guard: RolesGuard,
        roles: [
            'rockstar',
            'admin',
            'super admin',
            'digital marketing',
            'general manager',
            'sales manager',
            'marketing',
        ],
        component: lazy(() => import('src/views/uploadCsv')),
    },
    {
        exact: true,
        path: '/management/email-marketing',
        guard: PermissionsGuard,
        roles: {
            permission: EMAIL_MARKETING_AUTH,
            crud: READ_PERMISSION,
        },
        component: MailingView,
    },
];
